export enum DeviceSize {
  XSMALL,
  SMALL,
  MEDIUM,
  LARGE,
  XLARGE,
}

export enum Orientation {
  PORTRAIT,
  LANDSCAPE,
}

export interface IResponsiveState {
  deviceSize: DeviceSize;
  orientation: Orientation;
}

export const BREAKPOINTS: Record<DeviceSize, string> = {
  [DeviceSize.XSMALL]: '(max-width: 599.99px)',
  [DeviceSize.SMALL]: '(min-width: 600px) and (max-width: 959.99px)',
  [DeviceSize.MEDIUM]: '(min-width: 960px) and (max-width: 1279.99px)',
  [DeviceSize.LARGE]: '(min-width: 1280px) and (max-width: 1919.99px)',
  [DeviceSize.XLARGE]: '(min-width: 1920px)',
};

export const ORIENTATION_QUERIES: Record<Orientation, string> = {
  [Orientation.PORTRAIT]: '(orientation: portrait)',
  [Orientation.LANDSCAPE]: '(orientation: landscape)',
};
